import { render, staticRenderFns } from "./TaskDialog.vue?vue&type=template&id=2950eccc&"
import script from "./TaskDialog.vue?vue&type=script&lang=js&"
export * from "./TaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports